module.exports = __webpack_public_path__ + "media/images/diff-8286a1b757c5f50ada2c613e28334425.svg";